import { FormTemplatePropertyInfo } from './form-template-property-info';
import { KendoGridOperatorName } from '../../enums/kendo-grid/kendo-grid-operator-name.enum';
import { FormField } from '../form-builder/form-field.model';

// If you need to add a new metadata field, see this guide which covers what you need to do on both Server and Client: https://community-dc.max.gov/x/ooahmQ
export class MetadataFieldFactory {
    private constructor() { } // In essence makes this a static class.

    // Static methods.
    // Methods used for form template instances/"forms grid" fields generally used on site home pages.
    public static getFormTemplateInstancesMetadataProperties(): FormTemplatePropertyInfo[] {
        let availableProperties: FormTemplatePropertyInfo[] = [];

        availableProperties.push(new FormTemplatePropertyInfo('LinkedFormInstance', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals)); //added in VNEXT-1451
        availableProperties.push(new FormTemplatePropertyInfo('Favorite', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals));
        availableProperties.push(new FormTemplatePropertyInfo('Subscription', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals));
        availableProperties.push(new FormTemplatePropertyInfo('Id', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals));
        availableProperties.push(new FormTemplatePropertyInfo('Name', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));
        availableProperties.push(new FormTemplatePropertyInfo('FormTemplateName', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains)); // New for VNEXT-1491
        availableProperties.push(new FormTemplatePropertyInfo('FolderName', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));
        availableProperties.push(new FormTemplatePropertyInfo('FolderPath', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));
        availableProperties.push(new FormTemplatePropertyInfo('WorkflowState', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));

        //VNEXT-1099 - KLW: Adding fields to Site Homepage    
        availableProperties.push(new FormTemplatePropertyInfo('CreatedBy', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));
        availableProperties.push(new FormTemplatePropertyInfo('CreatedDate', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals));
        availableProperties.push(new FormTemplatePropertyInfo('ModifiedBy', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Contains));
        availableProperties.push(new FormTemplatePropertyInfo('ModifiedDate', FormTemplatePropertyInfo.METADATA).setDefaultFilterOperator(KendoGridOperatorName.Equals));

        return availableProperties;
    }

    public static getDummyMetaDataFormFields(): FormField[] { // Previously named populateDummyMetaDataFormFields().
        let idDummyFormField = new FormField();
        idDummyFormField.name = 'id';
        idDummyFormField.displayName = "Id";
        idDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.IntegerFieldDefinition"; //IdFieldType

        let nameDummyFormField = new FormField();
        nameDummyFormField.name = 'name';
        nameDummyFormField.displayName = "Name";
        nameDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition"; //FormInstanceNameFieldType

        let formTemplateNameDummyFormField = new FormField();
        formTemplateNameDummyFormField.name = 'formTemplateName';
        formTemplateNameDummyFormField.displayName = "FormTemplateName";
        formTemplateNameDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition";

        let folderPathDummyFormField = new FormField();
        folderPathDummyFormField.name = 'folderPath';
        folderPathDummyFormField.displayName = "FolderPath";
        folderPathDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition"; // FolderPathFieldType

        let folderNameDummyFormField = new FormField();
        folderNameDummyFormField.name = 'folderName';
        folderNameDummyFormField.displayName = "FolderName";
        folderNameDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition"; //FolderNameFieldType

        let workflowStateDummyFormField = new FormField();
        workflowStateDummyFormField.name = 'workflowState';
        workflowStateDummyFormField.displayName = "WorkflowState";
        workflowStateDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition"; //WorkflowStateFieldType

        let isLinkedFormInstanceDummyFormField = new FormField();
        isLinkedFormInstanceDummyFormField.name = 'LinkedFormInstance';
        isLinkedFormInstanceDummyFormField.displayName = "LinkedFormInstance";
        isLinkedFormInstanceDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.CheckBoxFieldDefinition"; //LinkedFormInstanceFieldType

        let isFavoriteDummyFormField = new FormField();
        isFavoriteDummyFormField.name = 'Favorite';
        isFavoriteDummyFormField.displayName = "Favorite";
        isFavoriteDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.CheckBoxFieldDefinition"; //FavoriteFieldType

        let subscriptionIdDummyFormField = new FormField();
        subscriptionIdDummyFormField.name = 'Subscription';
        subscriptionIdDummyFormField.displayName = "Subscription";
        subscriptionIdDummyFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.IntegerFieldDefinition"; //SubscriptionFieldType

        //VNEXT-1099 - KLW: Adding fields to Site Homepage
        let createdByFormField = new FormField();
        createdByFormField.name = 'createdByUserName';
        createdByFormField.displayName = "CreatedBy";
        createdByFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition";

        let createdByDisplayNameFormField = new FormField();
        createdByDisplayNameFormField.name = 'createdByDisplayName';
        createdByDisplayNameFormField.displayName = "CreatedByDisplayName";
        createdByDisplayNameFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition";

        let createdDateFormField = new FormField();
        createdDateFormField.name = 'createdDate';
        createdDateFormField.displayName = "CreatedDate";
        createdDateFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.DateFieldDefinition";

        let modifiedByFormField = new FormField();
        modifiedByFormField.name = 'modifiedByUserName';
        modifiedByFormField.displayName = "ModifiedBy";
        modifiedByFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition";

        let modifiedByDisplayNameFormField = new FormField();
        modifiedByDisplayNameFormField.name = 'modifiedByDisplayName';
        modifiedByDisplayNameFormField.displayName = "ModifiedByDisplayName";
        modifiedByDisplayNameFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.ShortTextFieldDefinition";

        let modifiedDateFormField = new FormField();
        modifiedDateFormField.name = 'modifiedDate';
        modifiedDateFormField.displayName = "ModifiedDate";
        modifiedDateFormField.fieldDefinitionClassName = "Collect.vNext.FieldDefinitions.DateFieldDefinition";

        let metadataDummyFormFields: FormField[] = [];
        metadataDummyFormFields.push(subscriptionIdDummyFormField);
        metadataDummyFormFields.push(isLinkedFormInstanceDummyFormField);
        metadataDummyFormFields.push(isFavoriteDummyFormField);
        metadataDummyFormFields.push(idDummyFormField);
        metadataDummyFormFields.push(nameDummyFormField);
        metadataDummyFormFields.push(formTemplateNameDummyFormField);
        metadataDummyFormFields.push(folderNameDummyFormField);
        metadataDummyFormFields.push(folderPathDummyFormField);
        metadataDummyFormFields.push(workflowStateDummyFormField);

        //VNEXT-1099 - KLW: Adding fields to Site Homepage
        metadataDummyFormFields.push(createdByFormField);
        metadataDummyFormFields.push(createdByDisplayNameFormField);
        metadataDummyFormFields.push(createdDateFormField);
        metadataDummyFormFields.push(modifiedByFormField);
        metadataDummyFormFields.push(modifiedByDisplayNameFormField);
        metadataDummyFormFields.push(modifiedDateFormField);

        return metadataDummyFormFields;
    }
}
